import { useToast } from '@monorepo/shared/contexts';
import { useNavigateToAdminFormTemplateEditor } from '../../../../../shared/hooks/navigation/useNavigateToAdminApp';
import { useFormTemplateCreate } from './useFormTemplateCreate';

export const useSaveNewFormTemplate = () => {
  const { showUserFriendlyErrorToast, success: showSuccessToast } = useToast();
  const goToFormTemplateEditor = useNavigateToAdminFormTemplateEditor();

  const [createFormTemplate, createFormTemplateState] = useFormTemplateCreate({
    config: {
      onSuccess: (savedFormTemplate) => {
        showSuccessToast(
          'Form saved. You will be redirected to the admin editor to finish setting up the form there.',
        );
        goToFormTemplateEditor(savedFormTemplate.id); // leaves the page
      },

      onError: (error) => {
        showUserFriendlyErrorToast(error, `Unable to save form.`, {
          dontAutoHide: true,
        });
      },
    },
  });

  return [createFormTemplate, createFormTemplateState] as const;
};
